module.exports = __webpack_public_path__ + "Jay lou-e697105c.png";